import { Loader2, RotateCw } from 'lucide-react'
import { PULL_THRESHOLD } from '@/hooks/usePullToRefresh'
import { cn } from '@/lib/utils'

const SIZE = 36
const REST_TOP = 12
/** Room the page keeps open under the top bar while refreshing, so the spinner covers nothing. */
export const REFRESHING_GAP = SIZE + REST_TOP * 2

/** The round badge that slides down from under the phone top bar as the page is pulled, and
 *  spins while the refresh runs. */
export function PullToRefreshIndicator({
  pull,
  refreshing,
}: {
  pull: number
  refreshing: boolean
}) {
  if (pull === 0 && !refreshing) return null
  const progress = Math.min(pull / PULL_THRESHOLD, 1)
  const ready = progress >= 1
  return (
    <div className="pointer-events-none relative z-20 lg:hidden">
      <div
        role={refreshing ? 'status' : undefined}
        aria-label={refreshing ? 'Refreshing' : undefined}
        className={cn(
          'absolute left-1/2 grid -translate-x-1/2 place-items-center rounded-full bg-[var(--fl-surface)] text-[var(--fl-primary)] shadow-[rgba(0,0,0,0.18)_0px_2px_8px]',
          !pull && 'transition-[top] duration-200'
        )}
        style={{
          width: SIZE,
          height: SIZE,
          top: refreshing ? REST_TOP : pull - SIZE + REST_TOP * progress,
          opacity: refreshing ? 1 : 0.4 + 0.6 * progress,
        }}
      >
        {refreshing ? (
          <Loader2 size={18} aria-hidden="true" className="animate-spin" />
        ) : (
          <RotateCw
            size={18}
            aria-hidden="true"
            strokeWidth={ready ? 2.5 : 2}
            style={{ transform: `rotate(${progress * 270}deg)` }}
          />
        )}
      </div>
    </div>
  )
}
